"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SwiperEjs = _interopRequireDefault(require("./Swiper.ejs.js"));

var _ikeaSharedComponent = require("@ikea-aoa/ikea-shared-component");

var _SwiperBodyRenderer = _interopRequireDefault(require("./render/SwiperBodyRenderer"));

var _SwiperPointer = _interopRequireDefault(require("./event/SwiperPointer"));

var _SwiperScroll = _interopRequireDefault(require("./event/SwiperScroll"));

var _SwiperAnimation = _interopRequireDefault(require("./render/SwiperAnimation"));

var _PageObserver = _interopRequireDefault(require("./utility/PageObserver"));

var _SwiperPosition = _interopRequireDefault(require("./pagination/SwiperPosition"));

var _SwiperInfo = _interopRequireDefault(require("./pagination/SwiperInfo"));

require("./Swiper.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var VALID_INTERACTION_TYPES = {
  CHEVRON: 'chevron',
  DOTS: 'dots',
  SWIPE: 'swipe',
  RESET: 'reset'
};
/**
 * This component is useful for swiping any element put inside it.
 *
 * The amount of items that fits on a page is calculated based on the item element size.
 *
 * @example
 * <ikea-component name="Swiper">
 *  <ikea-component-body>
 *    <div style="width: 10rem;">Item 1</div>
 *    <div style="width: 10rem;">Item 2</div>
 *    <div style="width: 10rem;">Item 3</div>
 *    <div style="width: 10rem;">Item 4</div>
 *    <div style="width: 10rem;">Item 5</div>
 *  </ikea-component-body>
 * </ikea-component>
 * @example
 * <Swiper>
 *  <div style="width: 10rem;">Item 1</div>
 *  <div style="width: 10rem;">Item 2</div>
 *  <div style="width: 10rem;">Item 3</div>
 *  <div style="width: 10rem;">Item 4</div>
 *  <div style="width: 10rem;">Item 5</div>
 * </Swiper>
 */

var Swiper = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(Swiper, _AbstractComponent);

  var _super = _createSuper(Swiper);

  /**
   * Class constructor.
   *
   * @param {Element} element The associated element.
   */
  function Swiper(element) {
    var _this;

    _classCallCheck(this, Swiper);

    _this = _super.call(this, element);
    _this.info = new _SwiperInfo.default();
    _this.position = new _SwiperPosition.default();
    _this.bodyRenderer = new _SwiperBodyRenderer.default(_this.info, element, _this.body);
    _this.animation = new _SwiperAnimation.default(_this.info, element);
    _this.pointer = new _SwiperPointer.default(_this.info, _this.animation, _this.position);
    _this.scroll = new _SwiperScroll.default(_this.info, _this.animation, _this.position);
    _this.pageObserver = new _PageObserver.default(element);
    _this.body.observerOptions.attributes = false;
    _this.info.useTranslate3d = _this.determineTranslate3dUsage();
    _this._isSceneLoaded = false;
    _this._renderBodyAfter = false;
    _this._renderSize = null;
    _this._interactionType = null;
    _this._previousIndex = null;
    return _this;
  }
  /**
   * Next page.
   */


  _createClass(Swiper, [{
    key: "nextPage",
    value: function nextPage() {
      this._interactionType = VALID_INTERACTION_TYPES.CHEVRON;
      this.slide(1);
    }
    /**
     * Previous page.
     */

  }, {
    key: "previousPage",
    value: function previousPage() {
      this._interactionType = VALID_INTERACTION_TYPES.CHEVRON;
      this.slide(-1);
    }
    /**
     * Slides a direction.
     *
     * @param {number} direction Direction.
     */

  }, {
    key: "slide",
    value: function slide(direction) {
      if (!this.props.disabled) {
        this.animation.transition(null, this._getDefaultTransitionTime() * 1.3);
        this.animation.setEasing('ease-in-out');
        this.position.slide(this.info.rtl ? -1 * direction : direction);
        this.render();
      }
    }
    /**
     * Slides to a page index.
     *
     * @param {number} pageIndex Page index to slide to.
     */

  }, {
    key: "slideTo",
    value: function slideTo(pageIndex) {
      if (!this.props.disabled) {
        this.animation.transition();
        this._interactionType = VALID_INTERACTION_TYPES.DOTS;
        this.position.setPageIndex(pageIndex);
        this.render();
      }
    }
    /**
     * Returns true if the swiper is at the begining.
     * It will check the opposite direction if RTL.
     *
     * @returns {boolean} TRUE if the swiper is at the begining.
     */

  }, {
    key: "isBegining",
    value: function isBegining() {
      return this.props.disabled || (this.info.rtl ? this.position.isEnd() : this.position.isBegining());
    }
    /**
     * Returns true if the swiper is at the end.
     * It will check the opposite direction if RTL.
     *
     * @returns {boolean} TRUE if the swiper is at the end.
     */

  }, {
    key: "isEnd",
    value: function isEnd() {
      return this.props.disabled || (this.info.rtl ? this.position.isBegining() : this.position.isEnd());
    }
    /**
     * Test for browsers which have trouble using translate3d under certain circumstances.
     * Ex: IE11 and animating videos.
     *
     * @returns {boolean} True.
     */

  }, {
    key: "determineTranslate3dUsage",
    value: function determineTranslate3dUsage() {
      var ie11 = !!window.MSInputMethodContext && !!document.documentMode;
      var translate3dEnabled = !ie11;
      return translate3dEnabled;
    }
    /**
     * Updates the swiper.
     *
     * @param {boolean} [forced=false] Forced render.
     */

  }, {
    key: "update",
    value: function update() {
      var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.animation.cancelTransitions();
      this.renderBody();
      this.render(forced);
    }
    /**
     * Called when the component is loaded the first time.
     *
     * @override
     */

  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      this.resizeHandler.on('resize', this.update.bind(this));
      this.scroll.on('scrollEnd', this.render.bind(this));
      this.pointer.on('swipeStart', function () {
        _this2._interactionType = VALID_INTERACTION_TYPES.SWIPE;

        _this2.scroll.disconnect();
      });
      this.body.on('change', this.update.bind(this));
      this.position.on('pageIndexChange', function (pageIndex) {
        return _this2.setProps({
          pageIndex: pageIndex
        });
      });
      this.pointer.on('swipeEnd', function () {
        _this2.render();

        _this2.scroll.connect();
      });

      if (this.props.observPage) {
        this.pageObserver.on('change', this.update.bind(this, true));
        this.pageObserver.connect();
      }
    }
    /**
     * Called when the component is removed.
     *
     * @override
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.pointer.disconnect();
      this.scroll.disconnect();
      this.pageObserver.disconnect();
      this.animation.cancelTransitions();
    }
    /**
     * Called before props are changed.
     *
     */

  }, {
    key: "propsWillChange",
    value: function propsWillChange() {
      this._previousIndex = this.props.pageIndex;
    }
    /**
     * Called when props has been changed.
     *
     * @override
     * @param {object} newProps Changed props.
     */

  }, {
    key: "propsHasChanged",
    value: function propsHasChanged(newProps) {
      if (newProps.vertical !== undefined) {
        this.position.setPageIndex(0);
        this.info.vertical = newProps.vertical;

        if (this._isSceneLoaded) {
          if (newProps.vertical) {
            this.scroll.connect();
          } else {
            this.scroll.disconnect();
          }
        }
      }

      if (newProps.disabled !== undefined && this._isSceneLoaded) {
        if (newProps.disabled) {
          this.scroll.disconnect();
          this.pointer.disconnect();
        } else {
          this.scroll.connect();
          this.pointer.connect();
        }
      }

      if (newProps.pageIndex !== undefined) {
        this.position.setPageIndex(newProps.pageIndex);

        if (this._isSceneLoaded) {
          this.trigger('pageChange', {
            previousIndex: this._previousIndex,
            index: newProps.pageIndex,
            interactionType: this._interactionType
          });
        }
      }

      if (newProps.steps !== undefined && this._isSceneLoaded) {
        this.info.steps = newProps.steps;
        this.renderBody();
      }

      if (newProps.vertical !== undefined || newProps.transitionDuration !== undefined || newProps.disabled !== undefined || newProps.pagination !== undefined) {
        this._resetEvent();
      }
    }
    /**
     * Gets the template.
     *
     * @override
     * @returns {Function} Template parse function.
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      this._updateRtl();

      return _SwiperEjs.default;
    }
    /**
     * Triggered after render.
     *
     * @override
     */

  }, {
    key: "afterRender",
    value: function afterRender() {
      if (!this._loadScene() && this._renderBodyAfter) {
        this._renderBodyAfter = false;
        this.renderBody();
      }
    }
    /**
     * Returns the container style.
     *
     * @returns {string} Container style.
     */

  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var position = this.position.getPosition();
      var translate;

      if (this.info.useTranslate3d) {
        translate = this.props.vertical ? "translate3d(0,".concat(position, "px,0)") : "translate3d(".concat(this.info.rtl ? position * -1 : position, "px,0,0)");
      } else {
        translate = this.props.vertical ? "translate(0,".concat(position, "px)") : "translate(".concat(this.info.rtl ? position * -1 : position, "px,0)");
      }

      return "transform: ".concat(translate, ";transition-duration: ").concat(this.animation.getTransitionDuration(), "ms;transition-timing-function: ").concat(this.animation.getEasing(), ";");
    }
    /**
     * Returns the wrapper style.
     *
     * @returns {string} Wrapper style.
     */

  }, {
    key: "getWrapperStyle",
    value: function getWrapperStyle() {
      return "width: ".concat(this.info.vertical || !this._renderSize || !this._renderSize.pageWidth ? 'auto' : this._renderSize.pageWidth + 'px', ";");
    }
    /**
     * Returns the swiper fade CSS classes.
     *
     * @returns {string} CSS classes.
     */

  }, {
    key: "getSwiperFadeClasses",
    value: function getSwiperFadeClasses() {
      var classes = [];
      var left = this.info.rtl ? 'left' : 'right';
      var right = this.info.rtl ? 'right' : 'left';

      if (this.props.fadeEdges && (this.props.fadeStartAndEnd || this.position.getPageIndex() != 0)) {
        classes.push('Swiper__wrapper--fade-' + right);
      }

      if (this.props.fadeEdges && (this.props.fadeStartAndEnd || this.position.getPageIndex() + 1 != this.position.getPages().length)) {
        classes.push('Swiper__wrapper--fade-' + left);
      }

      return classes.join(' ');
    }
    /**
     * Renders the body.
     */

  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$bodyRenderer$re = this.bodyRenderer.render(),
          pages = _this$bodyRenderer$re.pages,
          renderSize = _this$bodyRenderer$re.renderSize;

      this.position.setPages(pages);
      this.animation.defaultTransitionTime = this._getDefaultTransitionTime();
      this._renderSize = renderSize;
    }
    /**
     * Resets the swiper for next render.
     */

  }, {
    key: "reset",
    value: function reset() {
      this._interactionType = VALID_INTERACTION_TYPES.RESET;

      this._resetEvent();

      this.position.setPageIndex(0);
    }
    /**
     * Resets the swiper events for next render.
     */

  }, {
    key: "_resetEvent",
    value: function _resetEvent() {
      this.pointer.reset();
      this.scroll.reset();
      this.animation.cancelTransitions();
      this._renderBodyAfter = true;
    }
    /**
     * Updates RTL.
     */

  }, {
    key: "_updateRtl",
    value: function _updateRtl() {
      var rtl = document.querySelector('[dir="rtl"] .Swiper') !== null && !this.props.vertical;

      if (rtl !== this.info.rtl) {
        this.info.rtl = rtl;
        this.position.setPageIndex(0);
        this._renderBodyAfter = true;
      }
    }
    /**
     * Loads scene.
     *
     * @returns {boolean} TRUE if scene as loaded.
     */

  }, {
    key: "_loadScene",
    value: function _loadScene() {
      if (!this._isSceneLoaded) {
        this._isSceneLoaded = true;
        this.info.vertical = this.props.vertical;
        this.info.steps = this.props.steps;
        this.pointer.connect();
        this.renderBody();
        this.render();
        return true;
      }

      return false;
    }
    /**
     * Returns the default transition time based on pages.
     *
     * @returns {number} Transition time.
     */

  }, {
    key: "_getDefaultTransitionTime",
    value: function _getDefaultTransitionTime() {
      var pages = this.position.getPages();

      if (pages.length > 0 && pages[0].elements.length === 1) {
        return this.props.transitionDuration * 0.8;
      }

      return this.props.transitionDuration;
    }
    /**
     * Returns the supported props.
     *
     * @override
     * @summary
     * pagination: Choose between `arrows`, `dots`, `mobile-dots` or `none`.
     * pageIndex: Sets the current page index.
     * steps: Amount of items to slide per page. Set to "0" to slide all visible items.
     * transitionDuration: Transition duration in ms.
     * observPage: Set to `true` to observe changes to the page DOM.
     * vertical: Use the swiper in a vertical setting instead of horizontal.
     * fadeEdges: Fade the edges to show more content exists.
     * fadeStartAndEnd: Set to "true" to fade start and end.
     * disabled: Disable swipe events.
     * @returns {SupportedProp[]} Supported prop objects.
     */

  }], [{
    key: "supportedProps",
    get: function get() {
      return [new _ikeaSharedComponent.SupportedProp('pagination', 'string', false, ['arrows', 'dots', 'mobile-dots', 'arrows-and-dots', 'none'], 'arrows'), new _ikeaSharedComponent.SupportedProp('pageIndex', 'number', false, null, 0), new _ikeaSharedComponent.SupportedProp('steps', 'number', false, null, 0), new _ikeaSharedComponent.SupportedProp('transitionDuration', 'number', false, null, 500), new _ikeaSharedComponent.SupportedProp('observPage', 'boolean', false, null, true), new _ikeaSharedComponent.SupportedProp('vertical', 'boolean', false, null, false), new _ikeaSharedComponent.SupportedProp('fadeEdges', 'boolean', false, null, false), new _ikeaSharedComponent.SupportedProp('fadeStartAndEnd', 'boolean', false, null, false), new _ikeaSharedComponent.SupportedProp('disabled', 'boolean', false, null, false)];
    }
    /**
     * Returns an array of supported events.
     *
     * @override
     * @summary
     * pageChange: Triggered when page is changed. Event Data: { index: number, previousIndex: number, interactionType: interaction type  }
     * @returns {string[]} Supported event names. Example: ['click'].
     */

  }, {
    key: "supportedEvents",
    get: function get() {
      return ['pageChange'];
    }
    /**
     * Returns the component name.
     *
     * @override
     * @returns {string} Component name.
     */

  }, {
    key: "componentName",
    get: function get() {
      return 'Swiper';
    }
  }]);

  return Swiper;
}(_ikeaSharedComponent.AbstractComponent);

exports.default = Swiper;